import PrimaryBtn from "../../../components/primaryBtn/PrimaryBtn";
import "./AiLanding.scss";
import { Fragment, useState, useRef } from "react";
import { images } from "../../../utils/images";
import intoAudio from "../../../assets/audio/aiCall.mp4";
import AudioPlayer from "../../../components/audioPlayer/AudioPlayer";

const AiLanding = () => {
  const goToServic = () => {
    const section = document.getElementById("services");
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="ai_landing p_b">
      {images.dataAnalytics && (
        <Fragment>
          <img
            src={images.serviceBg}
            alt="Bg"
            className="img_bg"
            loading="lazy"
          />
        </Fragment>
      )}

      <div className="content_wrap">
        <div className="title pb-5">
          <h1>Your Smart Assistant</h1>
          <p className="para_text m">
            Say hello to your AI assistant that takes care of everyday business
            tasks — so you can focus on what truly matters.
          </p>
          <p className="para_text m">📞 Manage Incoming & Outbound Calls</p>
          <p  className="para_text">💬 Respond to customer messages</p>
          <p  className="para_text">📅 Handle bookings and reservations</p>

          <p className="para_text m">
            All in one place, in real time, and fully automated.
          </p>
          <PrimaryBtn
            varient="dark"
            title="Explore more"
            onClick={goToServic}
          />
        </div>
        <div className="ai_demo_sec">
          <div className="demo_card">
            <div className="content_card">
              <div className="profile_info">
                <div className="profile_wrap">
                  <img src={images.aiCalling} alt="Calling Person" />
                </div>
                <h4>Listen to a Sample Call</h4>
                <p>AI Receptionist</p>
              </div>
              <div className="audio_wrap">
                <AudioPlayer audioFile={intoAudio} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AiLanding;
